import {LAYOUTS} from '~/utils/constants/store';
export const getLayout = (storeCode) => {
  return LAYOUTS[storeCode] ? LAYOUTS[storeCode] : LAYOUTS.default;
}